(function () {
  var header = document.getElementById('previaHeader');
  var toggle = document.getElementById('previaNavToggle');
  var mobileNav = document.getElementById('previaNavMobile');

  function onScroll() {
    if (!header) return;
    if (window.scrollY > 60) {
      header.classList.add('is-solid');
    } else {
      header.classList.remove('is-solid');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }
})();